export const ERROR_KEYS = {
  CORPORATE_LOGIN_NOT_ENABLED: 'corporateLoginNotEnabled'
};

export const ERROR_MESSAGES = {
  [ERROR_KEYS.CORPORATE_LOGIN_NOT_ENABLED]: 'Corporate Login is not enabled for that user '
};
